import React from 'react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import AppRoutes from './routes/AppRoutes';

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

function App() {
  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <div id='dummy' style={{ padding:0, minHeight: '100vh', width: '100%' }}> 
        <AppRoutes /> 
      </div>
    </GoogleOAuthProvider>
  );
}

export default App;
